import { rootUiActions, rootUiTypes } from 'app-components/flux/root-ui';
import { Map as ImmutableMap } from 'immutable';
import { createAction } from 'redux-actions';

export const DIALOG_TYPE_TXN_SETTINGS = 'TRANSACTIONS_SETTINGS_DIALOG';

export const showTransactionsSettingsDialog = createAction(rootUiActions.createDialog.toString(), (props) =>
  rootUiTypes.mkRootUiData({
    type: DIALOG_TYPE_TXN_SETTINGS,
    id: DIALOG_TYPE_TXN_SETTINGS,
    props: ImmutableMap(props),
  }),
);
